import React, { useEffect } from 'react';

export const useDisableScrollInModal = disableScroll => {
  useEffect(
    () => {
      const mainWrapper = document.getElementById('main-wrap');

      if (!mainWrapper) return;

      if (disableScroll) {
        mainWrapper.style.overflow = 'hidden';
        mainWrapper.style.height = '100vh';
      } else {
        mainWrapper.style.overflow = 'visible';
        mainWrapper.style.height = '';
      }

      return () => {
        mainWrapper.style.overflow = 'visible';
      };
    },
    [disableScroll],
  );
};
